import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class CoreEventEvaluationService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/evaluation`);
  }

  listQuestions(urlParams: any): Observable<any> {
    const url = sprintf(`${this.baseUrl}/questions`, urlParams);
    return this.http.get<any>(url);
  }

  saveQuestions(body: any, urlParams: any): Observable<any> {
    const url = sprintf(`${this.baseUrl}/questions`, urlParams);
    return this.http.post<any>(url, body);
  }

  listResponses(urlParams: any): Observable<any> {
    const url = sprintf(`${this.baseUrl}/responses`, urlParams);
    return this.http.get<any>(url);
  }
}
